import SwapWalletsTransactionsPage from './SwapWalletsTransactionsPage.component'

export default SwapWalletsTransactionsPage
